/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, ContentChild, Inject} from '@angular/core';

import {IF_ACTIVE_ID, IF_ACTIVE_ID_PROVIDER, IfActiveService} from '../../utils/conditional/if-active.service';

import {AriaService} from './aria-service';
import {TabContent} from './tab-content';
import {TabLinkDirective} from './tab-link.directive';
import {TabsService} from './tabs-service';
export class Tab {
     tabLink: TabLinkDirective;
     tabContent: TabContent;
/**
 * @param {?} ifActiveService
 * @param {?} id
 * @param {?} tabsService
 */
constructor(public ifActiveService: IfActiveService,
public id: number,
private tabsService: TabsService) {
        tabsService.register(this);
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.tabsService.unregister(this);
    }
/**
 * @return {?}
 */
get active() {
        return this.ifActiveService.current === this.id;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-tab",
    template: `
        <ng-content></ng-content>
    `,
    providers: [IF_ACTIVE_ID_PROVIDER, AriaService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: IfActiveService, },
{type: undefined, decorators: [{ type: Inject, args: [IF_ACTIVE_ID, ] }, ]},
{type: TabsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tabLink': [{ type: ContentChild, args: [TabLinkDirective, ] },],
'tabContent': [{ type: ContentChild, args: [TabContent, ] },],
};
}

function Tab_tsickle_Closure_declarations() {
/** @type {?} */
Tab.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Tab.ctorParameters;
/** @type {?} */
Tab.propDecorators;
/** @type {?} */
Tab.prototype.tabLink;
/** @type {?} */
Tab.prototype.tabContent;
/** @type {?} */
Tab.prototype.ifActiveService;
/** @type {?} */
Tab.prototype.id;
/** @type {?} */
Tab.prototype.tabsService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
